import httpClient from '../httpClient';
import { Vehicle, VehicleTracker } from '../../models/Vehicle';
import { PaginatedData, PaginationParams } from 'models/Pagination';

function getVehicles(params?: PaginationParams) {
  return httpClient.get<PaginatedData<Vehicle>>('vehicles', {
    params,
  });
}

function getVehicle(id: string) {
  return httpClient.get<Vehicle>(`vehicles/${id}`);
}

function addVehicleTracker(
  vehicleId: string,
  tracker: Partial<VehicleTracker>,
) {
  return httpClient.post<Vehicle>(
    `vehicles/${vehicleId}/register-tracker`,
    tracker,
  );
}

function uploadVehicles(file: File) {
  const formData = new FormData();
  formData.append('file', file);
  return httpClient.post('vehicles/upload', formData);
}

function uploadVehiclesAdmin(file: File, fleetId: string) {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('fleetId', fleetId);
  return httpClient.post('vehicles/upload/admins', formData);
}

function syncWithDat(vehicleId: string) {
  return httpClient.post<Vehicle>(`vehicles/sync-dat`, { id: vehicleId });
}

export default {
  getVehicles,
  getVehicle,
  addVehicleTracker,
  uploadVehicles,
  uploadVehiclesAdmin,
  syncWithDat,
};
